// src/hooks/useQuestionnaireLifecycle.ts
import { useMutation, useQueryClient } from "@tanstack/react-query";

import {
  deleteQuestionnaire,
  deleteQuestionnaireVersion,
  unpublishQuestionnaireVersion,
} from "@/services/questionnaireLifecycle";

export function useDeleteQuestionnaire() {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: ({ questionnaireId }: { questionnaireId: string }) =>
      deleteQuestionnaire(questionnaireId),
    onSuccess: (_data, variables) => {
      qc.invalidateQueries({ queryKey: ["questionnaires"] });
      qc.removeQueries({
        queryKey: ["questionnaire_detail", variables.questionnaireId],
      });
      qc.removeQueries({
        queryKey: ["questionnaire_versions", variables.questionnaireId],
      });
    },
  });
}

export function useDeleteQuestionnaireVersion() {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: ({
      questionnaireId,
      versionId,
    }: {
      questionnaireId: string;
      versionId: string;
    }) => deleteQuestionnaireVersion(versionId),
    onSuccess: (_data, variables) => {
      qc.invalidateQueries({ queryKey: ["questionnaires"] });
      qc.invalidateQueries({
        queryKey: ["questionnaire_detail", variables.questionnaireId],
      });
      qc.invalidateQueries({
        queryKey: ["questionnaire_versions", variables.questionnaireId],
      });
      qc.removeQueries({
        queryKey: ["questionnaire_version_detail", variables.versionId],
      });
    },
  });
}

export function useUnpublishQuestionnaireVersion() {
  const qc = useQueryClient();

  return useMutation({
    mutationFn: ({
      questionnaireId,
      versionId,
    }: {
      questionnaireId: string;
      versionId: string;
    }) => unpublishQuestionnaireVersion(versionId),
    onSuccess: (_data, variables) => {
      qc.invalidateQueries({ queryKey: ["questionnaires"] });
      qc.invalidateQueries({
        queryKey: ["questionnaire_detail", variables.questionnaireId],
      });
      qc.invalidateQueries({
        queryKey: ["questionnaire_versions", variables.questionnaireId],
      });
      qc.invalidateQueries({
        queryKey: ["questionnaire_version_detail", variables.versionId],
      });
    },
  });
}
